import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, Chip,
  CircularProgress, Alert, Button, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Select, MenuItem,
  FormControl, InputLabel, Tabs, Tab, List, ListItem,
  ListItemText, ListItemIcon, Autocomplete
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import SchoolIcon from '@mui/icons-material/School';
import {
  getCursosAcademy, crearCursoAcademy, getLeccionesAcademy,
  getAcademyUsuarios, crearAcademyUsuario, asignarCurso,
  getAsignacionesCurso, getClientes, getUsuarios
} from '../api';

export default function Academy() {
  const [tab, setTab] = useState(0);
  const [cursos, setCursos] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [nuevoCursoDialog, setNuevoCursoDialog] = useState(false);
  const [nuevoCurso, setNuevoCurso] = useState({ titulo: '', descripcion: '', tipo_audiencia: 'ambos' });
  const [cursoDetalle, setCursoDetalle] = useState<any>(null);
  const [lecciones, setLecciones] = useState<any[]>([]);
  const [academyUsuarios, setAcademyUsuarios] = useState<any[]>([]);
  const [clientesLista, setClientesLista] = useState<any[]>([]);
  const [empleadosLista, setEmpleadosLista] = useState<any[]>([]);
  const [nuevoClienteDialog, setNuevoClienteDialog] = useState(false);
  const [nuevoClienteAcademy, setNuevoClienteAcademy] = useState({ nombre: '', email: '', password: '', cliente_id: null as any });
  const [asignarDialog, setAsignarDialog] = useState<any>(null);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const esAdmin = ['admin', 'jefe'].includes(user.rol);

  const cargar = () => {
    setLoading(true);
    getCursosAcademy().then(setCursos).finally(() => setLoading(false));
    if (esAdmin) {
      getAcademyUsuarios().then(setAcademyUsuarios);
      getClientes().then(setClientesLista);
      getUsuarios().then(setEmpleadosLista);
    }
  };

  useEffect(() => { cargar(); }, []);

  const handleCrearCurso = async () => {
    await crearCursoAcademy(nuevoCurso);
    setNuevoCursoDialog(false);
    setNuevoCurso({ titulo: '', descripcion: '', tipo_audiencia: 'ambos' });
    cargar();
  };

  const handleVerCurso = async (curso: any) => {
    setCursoDetalle(curso);
    const lecs = await getLeccionesAcademy(curso.id);
    setLecciones(lecs);
  };

  const handleCrearClienteAcademy = async () => {
    try {
      await crearAcademyUsuario(nuevoClienteAcademy);
      setNuevoClienteDialog(false);
      setNuevoClienteAcademy({ nombre: '', email: '', password: '', cliente_id: null });
      cargar();
      alert('✅ Usuario de Academy creado');
    } catch (e) {
      alert('Error al crear — el email ya existe');
    }
  };

  const handleAsignar = async (tipo: 'cliente' | 'empleado', id: number) => {
    if (!asignarDialog) return;
    try {
      await asignarCurso(asignarDialog.id, tipo === 'cliente' ? { academy_usuario_id: id } : { tecnico_id: id });
      alert('✅ Curso asignado');
    } catch {
      alert('Error al asignar');
    }
  };

  const lecionIcon = (tipo: string) => tipo === 'video' ? <PlayCircleIcon /> : <PictureAsPdfIcon />;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' } }}>
          🎓 HEI Academy
        </Typography>
        {esAdmin && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="outlined" onClick={() => setNuevoClienteDialog(true)}>
              👤 Nuevo usuario cliente
            </Button>
            <Button
              variant="contained" startIcon={<AddIcon />}
              onClick={() => setNuevoCursoDialog(true)}
              sx={{ bgcolor: '#4f46e5' }}
            >
              Nuevo curso
            </Button>
          </Box>
        )}
      </Box>

      {esAdmin && (
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
          <Tab label="📚 Cursos" />
          <Tab label="👥 Usuarios cliente" />
        </Tabs>
      )}

      {loading && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>}

      {(!esAdmin || tab === 0) && (
        <Grid container spacing={2}>
          {cursos.map(c => (
            <Grid item xs={12} sm={6} md={4} key={c.id}>
              <Card sx={{ borderRadius: 3, cursor: 'pointer', '&:hover': { boxShadow: 4 } }} onClick={() => handleVerCurso(c)}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <SchoolIcon sx={{ color: '#4f46e5' }} />
                    <Typography sx={{ fontWeight: 600 }}>{c.titulo}</Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary">{c.descripcion}</Typography>
                  <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                    <Chip label={`${c.n_lecciones} lecciones`} size="small" />
                    <Chip label={c.tipo_audiencia} size="small" color="info" />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {cursos.length === 0 && !loading && (
            <Grid item xs={12}><Alert severity="info">No hay cursos disponibles todavía.</Alert></Grid>
          )}
        </Grid>
      )}

      {esAdmin && tab === 1 && (
        <Grid container spacing={2}>
          {academyUsuarios.map(u => (
            <Grid item xs={12} sm={6} key={u.id}>
              <Card sx={{ borderRadius: 3 }}>
                <CardContent>
                  <Typography sx={{ fontWeight: 600 }}>{u.nombre}</Typography>
                  <Typography variant="body2" color="text.secondary">{u.email}</Typography>
                  <Typography variant="caption" color="text.secondary">Cliente: {u.cliente_nombre || '—'}</Typography>
                  <Chip label={u.activo ? 'Activo' : 'Inactivo'} color={u.activo ? 'success' : 'default'} size="small" sx={{ mt: 1, display: 'block', width: 'fit-content' }} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Dialog detalle curso */}
      <Dialog open={!!cursoDetalle} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setCursoDetalle(null); } }} maxWidth="sm" fullWidth>
        <DialogTitle>{cursoDetalle?.titulo}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{cursoDetalle?.descripcion}</Typography>
          <List>
            {lecciones.map(l => (
                <ListItem key={l.id} component="a" href={`/academy/lecciones/${l.id}/archivo`} target="_blank">
                <ListItemIcon>{lecionIcon(l.tipo)}</ListItemIcon>
                <ListItemText primary={l.titulo} secondary={l.descripcion} />
              </ListItem>
            ))}
            {lecciones.length === 0 && <Alert severity="info">Este curso no tiene lecciones todavía.</Alert>}
          </List>
          {esAdmin && (
            <Button fullWidth variant="outlined" sx={{ mt: 2 }} onClick={() => { setAsignarDialog(cursoDetalle); }}>
              👥 Asignar a usuarios
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCursoDetalle(null)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog nuevo curso */}
      <Dialog open={nuevoCursoDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setNuevoCursoDialog(false); } }} maxWidth="sm" fullWidth>
        <DialogTitle>📚 Nuevo curso</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField label="Título" value={nuevoCurso.titulo} onChange={(e) => setNuevoCurso({ ...nuevoCurso, titulo: e.target.value })} />
            <TextField label="Descripción" multiline rows={3} value={nuevoCurso.descripcion} onChange={(e) => setNuevoCurso({ ...nuevoCurso, descripcion: e.target.value })} />
            <FormControl fullWidth>
              <InputLabel>Audiencia</InputLabel>
              <Select value={nuevoCurso.tipo_audiencia} label="Audiencia" onChange={(e) => setNuevoCurso({ ...nuevoCurso, tipo_audiencia: e.target.value })}>
                <MenuItem value="ambos">Empleados y clientes</MenuItem>
                <MenuItem value="empleados">Solo empleados</MenuItem>
                <MenuItem value="clientes">Solo clientes</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNuevoCursoDialog(false)}>Cancelar</Button>
          <Button onClick={handleCrearCurso} variant="contained" sx={{ bgcolor: '#4f46e5' }} disabled={!nuevoCurso.titulo}>
            Crear curso
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog nuevo usuario cliente */}
      <Dialog open={nuevoClienteDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setNuevoClienteDialog(false); } }} maxWidth="sm" fullWidth>
        <DialogTitle>👤 Nuevo usuario de Academy (cliente)</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <TextField label="Nombre" value={nuevoClienteAcademy.nombre} onChange={(e) => setNuevoClienteAcademy({ ...nuevoClienteAcademy, nombre: e.target.value })} />
            <TextField label="Email" value={nuevoClienteAcademy.email} onChange={(e) => setNuevoClienteAcademy({ ...nuevoClienteAcademy, email: e.target.value })} />
            <TextField label="Contraseña" type="password" value={nuevoClienteAcademy.password} onChange={(e) => setNuevoClienteAcademy({ ...nuevoClienteAcademy, password: e.target.value })} />
            <Autocomplete
              options={clientesLista}
              getOptionLabel={(c: any) => c.nombre}
              onChange={(_, val) => setNuevoClienteAcademy({ ...nuevoClienteAcademy, cliente_id: val?.id })}
              renderInput={(params) => <TextField {...params} label="Vincular a cliente" />}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNuevoClienteDialog(false)}>Cancelar</Button>
          <Button onClick={handleCrearClienteAcademy} variant="contained" sx={{ bgcolor: '#4f46e5' }} disabled={!nuevoClienteAcademy.nombre || !nuevoClienteAcademy.email}>
            Crear usuario
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog asignar curso */}
      <Dialog open={!!asignarDialog} onClose={(e, r) => { if (r !== 'backdropClick' && r !== 'escapeKeyDown') { setAsignarDialog(null); } }} maxWidth="sm" fullWidth>
        <DialogTitle>👥 Asignar curso — {asignarDialog?.titulo}</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>Asignar a cliente</Typography>
          <Autocomplete
            options={academyUsuarios}
            getOptionLabel={(u: any) => `${u.nombre} (${u.email})`}
            onChange={(_, val) => val && handleAsignar('cliente', val.id)}
            renderInput={(params) => <TextField {...params} label="Buscar usuario cliente" />}
            sx={{ mb: 3 }}
          />
          <Typography variant="subtitle2" sx={{ mb: 1 }}>Asignar a empleado</Typography>
          <Autocomplete
            options={empleadosLista}
            getOptionLabel={(u: any) => `${u.nombre} ${u.apellidos}`}
            onChange={(_, val) => val && handleAsignar('empleado', val.id)}
            renderInput={(params) => <TextField {...params} label="Buscar empleado" />}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAsignarDialog(null)} variant="contained" sx={{ bgcolor: '#4f46e5' }}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}